/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Adust Collection heights when page is loaded 
window.addEventListener('load', (event) => {
  try{
    for(i=0;i<document.querySelectorAll('.flickity-viewport').length;i++)
      {
        var maxheight = 0;
        if(document.querySelectorAll('.flickity-viewport')[i].querySelector('.Carousel__Cell').offsetHeight > document.querySelectorAll('.flickity-viewport')[i].offsetHeight)
        {
          for(j=0;j<document.querySelectorAll('.flickity-viewport')[i].querySelectorAll('.Carousel__Cell').length;j++)
            {
              if (maxheight < document.querySelectorAll('.flickity-viewport')[i].querySelectorAll('.Carousel__Cell')[j])
              {
                maxheight = document.querySelectorAll('.flickity-viewport')[i].querySelectorAll('.Carousel__Cell')[j].offsetHeight;
              }
            }
        }
      }
  }
  catch (error) {
    console.log(error);
    // expected output: ReferenceError: nonExistentFunction is not defined
    // Note - error messages will vary depending on browser
  }
  
});


// check if custom sliderpoints are nessecary

window.addEventListener('load', (event) => {
  var colls = document.querySelectorAll('[data-section-type="featured-collections"] .ProductList, [data-section-type="product-recommendations"] .ProductList');
   
  colls.forEach((coll) => {
    if(window.innerWidth <= 1005)
    { 
      const intervalID = setInterval(function(){
        var dotnumber = coll.scrollWidth / coll.parentNode.scrollWidth;
        if(dotnumber > 1.5)
        {
          clearInterval(intervalID);
          rebuildMobileDots(coll);
        }
      }, 100);
    } 
  });  
});     

  // on every breakpoint change check again if slider points are nessecary
  
document.addEventListener('breakpoint:changed', function(){
  var colls = document.querySelectorAll('[data-section-type="featured-collections"] .ProductList');
  var mobilePoints = document.querySelectorAll('.flickity-page-dots.mobile-only');
  
  if(mobilePoints[0]){
    mobilePoints.forEach(element => {
      element.remove();
    });
  }

  colls.forEach((coll) => {
    if(event.detail.currentBreakpoint != 'lap')
    { 
      const intervalID = setInterval(function(){
        var dotnumber = coll.scrollWidth / coll.parentNode.scrollWidth;
        if(dotnumber > 1.5)
        {
          clearInterval(intervalID);
          rebuildMobileDots(coll);
        }
      }, 100);
    }
  });
});
 
              
  // build custom slider points
  
function rebuildMobileDots(coll)
{ 
    // Create a new "ol" element
    const newOlElement = document.createElement('ol');
    newOlElement.classList.add('flickity-page-dots');
    newOlElement.classList.add('mobile-only');

    var dotnumber = coll.scrollWidth / coll.parentNode.scrollWidth;
    var activenumber = Math.floor(coll.scrollLeft / coll.parentNode.scrollWidth);

    // Add "li" elements to the "ol" element
    for (let i = 0; i < Math.floor(dotnumber); i++) {
      const liElement = document.createElement('li');
      liElement.classList.add('dot');
      if (i === activenumber) {
        liElement.classList.add('is-selected');
      }
      newOlElement.appendChild(liElement);      
    }

    // Add click event listener to dots
    newOlElement.querySelectorAll('.dot').forEach(dot => {
      dot.addEventListener('click', () => {
        index = Array.prototype.indexOf.call(newOlElement.children, dot);
        var scrollposition = Math.floor(coll.scrollWidth / dotnumber * index);
        coll.scrollLeft = scrollposition;
        setTimeout(function() {
          // Remove is-selected class from all dots
          newOlElement.querySelectorAll('.dot').forEach(dot => {
            dot.classList.remove('is-selected');
          });
          // Add is-selected class to clicked dot
          dot.classList.add('is-selected');
        }, 50);
      });
    });

    // Listen for touchend of elment, find scroll value and change selected dot

    let isScrolling = false;
    
    coll.addEventListener('scroll', function() {
      isScrolling = true;
    });
    
    setInterval(function() {
      if (isScrolling) {
        isScrolling = false;
        var activenumber = Math.floor(coll.scrollLeft / coll.parentElement.scrollWidth);
        // Remove is-selected class from all dots, Add is-selected class to clicked dot
        newOlElement.querySelectorAll('.dot').forEach((dot, v) => {
          dot.classList.remove('is-selected');
          if (v == activenumber){
            dot.classList.add('is-selected');
          }
        });
      }
    }, 50);
    
    // Insert the new "ol" element after the "coll" element
    coll.parentNode.insertBefore(newOlElement, coll.nextSibling);
}


